/**
 * Stable built-in component type ids shared by schema exports and cross-SDK
 * protocol serializers.
 */
export const ComponentTypeID = {
    // Reserved
    Reserved: 0,
    // Layout components
    Stack: 1,
    StackRow: 2,
    Box: 3,
    Grid: 4,
    Spacer: 5,
    Divider: 6,
    StackCol: 7,
    GridItem: 8,
    ScrollArea: 9,
    // Typography components
    Text: 10,
    Heading: 11,
    Label: 12,
    Code: 13,
    Flex: 14,
    CodeBlock: 15,
    // Interactive components
    Button: 20,
    ButtonGroup: 21,
    Link: 22,
    NavTree: 23,
    NavTreeSection: 24,
    NavTreeItem: 25,
    DropdownMenu: 70,
    DropdownMenuTrigger: 71,
    DropdownMenuContextTrigger: 72,
    DropdownMenuContent: 73,
    DropdownMenuItem: 74,
    DropdownMenuCheckboxItem: 75,
    DropdownMenuRadioGroup: 76,
    DropdownMenuRadioItem: 77,
    DropdownMenuGroup: 78,
    DropdownMenuLabel: 79,
    DropdownMenuSeparator: 80,
    DropdownMenuShortcut: 81,
    DropdownMenuSub: 82,
    DropdownMenuSubTrigger: 83,
    DropdownMenuSubContent: 84,
    ModalTrigger: 85,
    ModalBackdrop: 86,
    ModalPositioner: 87,
    ModalContent: 88,
    ModalHeader: 89,
    ModalTitle: 90,
    ModalDescription: 91,
    ModalBody: 92,
    ModalFooter: 93,
    ModalCloseTrigger: 94,
    ModalActionTrigger: 95,
    Table: 96,
    TableScrollArea: 97,
    TableCaption: 98,
    TableColumnGroup: 99,
    TableColumn: 100,
    TableHeader: 101,
    TableBody: 102,
    TableFooter: 103,
    TableRow: 104,
    TableColumnHeader: 105,
    TableCell: 106,
    Breadcrumb: 107,
    BreadcrumbList: 108,
    BreadcrumbItem: 109,
    BreadcrumbLink: 110,
    BreadcrumbCurrentLink: 111,
    BreadcrumbSeparator: 112,
    BreadcrumbEllipsis: 113,
    Accordion: 114,
    AccordionItem: 115,
    AccordionTrigger: 116,
    AccordionIndicator: 117,
    AccordionContent: 118,
    AccordionBody: 119,
    Chart: 120,
    Tabs: 121,
    TabsList: 122,
    TabsTrigger: 123,
    TabsContent: 124,
    // Form components
    Input: 30,
    Textarea: 31,
    Select: 32,
    Checkbox: 33,
    Radio: 34,
    Switch: 35,
    Flyout: 36,
    FlyoutItem: 37,
    Field: 47,
    FieldLabel: 48,
    FieldDescription: 49,
    FieldError: 50,
    FieldGroup: 51,
    FieldSet: 52,
    FieldLegend: 53,
    CheckboxGroup: 54,
    RadioGroup: 55,
    SegmentedControl: 56,
    InputCharacterCount: 57,
    Composer: 60,
    StreamingText: 61,
    MessagePair: 62,
    ToolCall: 63,
    // Feedback components
    Modal: 40,
    Dialog: 41,
    Popover: 42,
    Tooltip: 43,
    Spinner: 44,
    Progress: 45,
    Alert: 46,
    Toast: 58,
    Toaster: 59,
    // Custom (plugin-defined)
    CustomBase: 1000,
};
//# sourceMappingURL=component-ids.js.map